import {Record} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';

export interface SafeguardingStateProps {
    readonly loading: boolean;
    readonly loadingMore: boolean;
    readonly apiData?: any;
    readonly cursor: string | null;
    readonly showEmptyState: boolean;
    readonly initialLoading: boolean;
}

export class SafeguardingState extends Record<SafeguardingStateProps>({
    loading: false,
    loadingMore: false,
    apiData: undefined,
    cursor: null,
    showEmptyState: false,
    initialLoading: false,
}) {}

export default makeReducer<SafeguardingState>(
    [
        match(Actions.fetchReports, (state, {payload}) =>
            state.merge({
                loading: payload.cursor === null,
                loadingMore: payload.cursor !== null,
            }),
        ),
        match(Actions.fetchReportsSuccess, (state, {payload}) =>
            state.merge({
                loading: false,
                loadingMore: false,
                apiData: payload.append ? mergeRows(state.apiData, payload.apiData) : payload.apiData,
                cursor: payload.apiData.cursor,
            }),
        ),
        match(Actions.fetchReportsFailed, state =>
            state.merge({
                loading: false,
                loadingMore: false,
                cursor: null,
            }),
        ),
        match(Actions.initialFetchReports, state =>
            state.merge({
                initialLoading: true,
            }),
        ),
        match(Actions.initialFetchReportsSuccess, (state, {payload}) =>
            state.merge({
                initialLoading: false,
                showEmptyState: !hasApiData(payload),
            }),
        ),
        match(Actions.initialFetchReportsFailed, state =>
            state.merge({
                initialLoading: false,
            }),
        ),
        match(Actions.hideEmptyState, state =>
            state.merge({
                showEmptyState: false,
            }),
        ),
    ],
    new SafeguardingState(),
);

const hasApiData = (payload: any) => {
    if (payload.apiData && payload.apiData?.table?.rows?.length > 0) {
        return true;
    }
    return false;
};

const mergeRows = (currentData: any, newData: any) => {
    return {
        ...currentData,
        table: {
            ...newData.table,
            rows: [...currentData.table.rows, ...newData.table.rows],
        },
    };
};
